import React from 'react';
import { Link } from 'react-router-dom';

function WidPages() {
    return (
        <div className="single-footer-wid">
            <div className="wid-title">
                <h4>Quick Links</h4>
            </div>
            <ul>
                <li>
                    <Link to="/">Home</Link>
                </li>
                <li>
                    <Link to="/gallery">Gallery</Link>
                </li>
                <li>
                    <Link to="/about">About Us</Link>
                </li>
                <li>
                    <Link to="/contact">Contact Us</Link>
                </li>
            </ul>
        </div>
    );
}

export default WidPages;
